import React from "react";
import style from "./RadioGroup.module.scss";

const RadioGroup = ({ options, selectedValue, onChange, colCnt, disabled = false, marginLeft = '0px' }) => {
    const isGrid = colCnt && typeof colCnt === "number" && colCnt > 0;
    const containerClass = isGrid ? style.radio_group2_container : style.custom_radio_group;

    // 전체 컨테이너 스타일: marginLeft 반영
    const containerStyle = {
        ...(isGrid ? { gridTemplateColumns: `repeat(${colCnt}, auto)` } : {}),
        marginLeft: `${marginLeft}`, // 왼쪽 여백 적용
    };
    // 초기화 핸들러
    const handleReset = () => {
        if (disabled) return;
        onChange(""); // 부모 상태를 빈 값으로 변경
    };

    return (
      <div className={style.radio_group_wrapper} style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          <div className={containerClass} style={containerStyle}>
              {options.map((option) => (
                <label
                  key={option.value}
                  className={`${style.radio_label} ${selectedValue === option.value ? style.selected : ""} ${
                    disabled ? style.disabled : ""
                  }`}
                >
                    <input
                      type="radio"
                      name="custom-radio"
                      value={option.value}
                      checked={selectedValue === option.value}
                      onChange={() => onChange(option.value)}
                      className={style.radio_input}
                      disabled={disabled}
                    />
                    <span className={style.radio_custom}></span>
                    <span className={style.radio_label__text}>{option.label}</span>
                </label>
              ))}
          </div>

          {/* 값이 선택되어 있고, disabled가 아닐 때만 X 버튼 표시 */}
          {selectedValue && !disabled && (
            <button
              type="button"
              onClick={handleReset}
              className={style.radio_reset_btn}
              title="선택 초기화"
              aria-label="선택 초기화"
            >
                ↺
            </button>
          )}
      </div>
    );
};

export default RadioGroup;
